import { render, staticRenderFns } from "./StoreUsersDeleteBtn.vue?vue&type=template&id=f455b3b2"
import script from "./StoreUsersDeleteBtn.vue?vue&type=script&lang=js"
export * from "./StoreUsersDeleteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports